import { maybe } from "@passionware/monads";
import store from "store/index";
import { selectActiveTeam } from "store/teams/index";
import { ApiClient } from '../../../lib/api/ApiClient.types';
import { BookingStatisticsApi } from './booking-statistics.api';
import { bookingStatisticsResponse$ } from './booking-statistics.api.http.schema';
import { format } from 'date-fns';

export function createBookingStatisticsApi(
  client: ApiClient
): BookingStatisticsApi {
  return {
    async getData(query, signal) {
      // todo team should be part of the query
      const team = maybe.getOrThrow(selectActiveTeam(store.getState()), 'No active team found');
      const response = await client.get(
        `/core/teams/${team.dbSchema}/bookings/total-booked-hours/${query.resourceId}`,
        {
          signal,
          params: {
            fromDate: query.startDate
              ? format(query.startDate, 'yyyy-MM-dd')
              : undefined,
            toDate: query.endDate
              ? format(query.endDate, 'yyyy-MM-dd')
              : undefined
          },
          token: true,
          isV2: true
        }
      );

      const parsedResponse = bookingStatisticsResponse$.parse(response).data;

      return {
        totalHours: parsedResponse.totalHours,
        estimatedCosts: {
          approximateCosts: {
            currency: parsedResponse.totalCosts.currency,
            value: parsedResponse.totalCosts.amount
          },
          currencies: [
            {
              currency: parsedResponse.totalCosts.currency,
              value: parsedResponse.totalCosts.amount
            }
          ]
        }
      };
    }
  };
}
